import mapValues from "lodash.mapvalues";
import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  cityValidator,
  emailValidator,
  genericStringValidatorRequired,
  nameSurnameValidatorRequired,
  phoneValidatorRequired,
  postalCodePolandValidator,
  radioValidator,
  streetHouseNumberValidator,
  streetValidator,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

const multiPersonValidator = {
  persons: yup.lazy((obj) =>
    yup.object(
      mapValues(obj, (_, key) => {
        return yup.object({
          name: nameSurnameValidatorRequired,
          surname: nameSurnameValidatorRequired,
          phone: phoneValidatorRequired(`otherPersonspersons${key}phone`),
          email: emailValidator,
          street: streetValidator,
          street2: streetHouseNumberValidator,
          zipCode: postalCodePolandValidator,
          city: cityValidator,
        });
      })
    )
  ),
};

export const validator = {
  [FormId.INCIDENT_OTHER_PERSONS]: yup.object({
    [ComponentId.NUMBER_OF_PARTICIPANTS]: genericStringValidatorRequired,
    [ComponentId.ARE_INJURED_PERSONS]: radioValidator,
    [ComponentId.GOT_INJURED_PERSONS_DETAILS]: trimmedString.onlyIfFieldIsVisible(
      radioValidator
    ),
    ...multiPersonValidator,
  }),
};
